import { Button, type ButtonProps } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useTranslation } from "react-i18next";

type ConsentPreviewButtonProps = Omit<ButtonProps, "children"> & {
    label?: string;
};

export const ConsentPreviewButton = ({
    label,
    size = "small",
    type = "button",
    variant = "secondary",
    ...buttonProps
}: ConsentPreviewButtonProps) => {
    const { t } = useTranslation();

    return (
        <Button
            size={size}
            type={type}
            variant={variant}
            startIcon={<VisibilityOutlinedIcon fontSize="small" />}
            {...buttonProps}
        >
            {label ?? t("settings.consent.preview.action", "Preview")}
        </Button>
    );
};
